/**
 * Triggers a browser download for the given content.
 * @param {{ content: string|Blob, fileName: string, mimeType?: string }} file
 */
export function saveAs({ content, fileName, mimeType = "text/plain;charset=utf-8" }) {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
